<template>
  <div class="add-address" v-loading.fullscreen.lock="isLoading" element-loading-background="rgba(256, 256, 256, 0.6)">
    <div class="form-group">
      <address-lookup-form :address="address" :placeholderText="placeholderText" @updateAddress='setAddress'
        :isNewAddress="isNewAddress" />
    </div>
    <div id="submit-button">
      <n-button :style="myTheme.customizeButton" round :disabled="!isCompleted" @click="saveAddress()">{{ isNewAddress ?
        $t("button.add_address") : $t("button.save_changes") }}</n-button>
    </div>
  </div>
</template>
<script>
import { FormGroupInput, Button, FormTexterea, Checkbox } from "@/components";
import { mapActions } from "vuex";
import objectAddress from "@/model/address";
import { showErrorMessageAlert, getMessageFromAPIError } from "@/utilities/helper";
import { AddressLookupForm } from "@/views/components";


export default {
  name: 'add-address',
  components: {
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [FormTexterea.name]: FormTexterea,
    AddressLookupForm,
  },
  props: {
    fromModal: Boolean,
    isNewAddress: Boolean,
    address: Object
  },
  computed: {
    isCompleted() {
      return (
        this.address && this.address.postcode && this.address.address_line_1 && (this.address.lat && this.address.lng)
        && this.address.city && this.address.region && this.address.country && this.address.street_number
      );
    }
  },
  data() {
    return {
      addressData: Object.assign({}, objectAddress),
      isLoading: false,
      autocompleteText: "",
      placeholderText: this.$t('input.placeholder.start_typing'),
    };
  },
  methods: {
    ...mapActions('userStore', ["addNewAddress", "updateAddressRequest"]),
    setAddress(addressData) {
      this.addressData = addressData;
    },
    saveAddress() {
      let self = this;
      this.isLoading = true;
      if (this.isNewAddress) {
        this.addNewAddress(this.addressData)
          .then((response) => {
            if (response && response.error) {
              showErrorMessageAlert(
                getMessageFromAPIError(response)
              );
              return;
            }
            self.isLoading = false;
            this.clearAddress();
            if (this.fromModal)
              this.$emit('exit', { show: false, address: response.data });

            self.$notify({
              group: "bottomRight",
              title: this.$t("message.resource_added_notify_title", { resource_name: "Address" }),
              type: "success",
              text: this.$t("message.resource_added_notify_message", { resource_name: "Address" })
            });
          })
          .catch((e) => {
            this.captureException(e)
            this.isLoading = false
            self.$notify({
              group: "bottomRight",
              title: this.$t("message.resource_error_notify_title", { resource_name: "Address" }),
              type: "danger",
              text: this.$t("message.resource_error_notify_message", { resource_name: "Address" })
            });
          });

      } else if (this.address.id && this.address.id > 0) {
        this.updateAddressRequest(this.address)
          .then((response) => {
            if (response && response.error) {
              showErrorMessageAlert(
                getMessageFromAPIError(response)
              );
              return;
            }
            self.isLoading = false;
            this.clearAddress();
            if (this.fromModal) {
              this.$emit('exit', { show: false, address: response });
            }

            self.$notify({
              group: "bottomRight",
              title: this.$t("message.address_updated_notify_title"),
              type: "success",
              text: this.$t("message.address_updated_notify_message")
            });
          })
          .catch((e) => {
            this.captureException(e)
            this.isLoading = false
            self.$notify({
              group: "bottomRight",
              title: this.$t("message.resource_error_notify_title", { resource_name: "Address" }),
              type: "danger",
              text: this.$t("message.resource_error_update_notify_message", { resource_name: "Address" })
            });
          });
      } else {
        this.isLoading = false
        self.$notify({
          group: "bottomRight",
          title: this.$t("message.resource_error_notify_title", { resource_name: "Address" }),
          type: "danger",
          text: this.$t("message.resource_error_update_notify_message", { resource_name: "Address" })
        });
      }
    },
    clearAddress() {
      this.placeholderText = this.$t("input.placeholder.start_typing");
      this.addressData = Object.assign({}, objectAddress);
    }
  },
};
</script>
<style scoped>
.form-group.input-group {
  padding: 0;
}

#search-address {
  padding-bottom: 5px;
}

#submit-button {
  margin: auto;
  text-align: center;
}
</style>
